import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import Offlinestore from "app/pages/MyBranches";
import AddEditOfflinestore from "app/pages/MyBranches/AddEditOfflineStore";


const routesName = "/dashboards/myBranch";
const modules = "myBranch";

export const myBranchRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={Offlinestore} />
      },
      {
        path: `${routesName}/add`,
        element: <Page component={AddEditOfflinestore} />,
      },
      {
        path: `${routesName}/edit/:id`,
        element: <Page component={AddEditOfflinestore} />,
      },
    ],
  },]
  